// utils/downloadOlympiadPDF.js

import html2pdf from "html2pdf.js";
import LogoMittsure from "../newLogo2204.PNG";

const downloadOlympiadPDF = (data) => {
  console.log("Generating PDF with data:", data);

  if (!data) return;

  // ✅ Financial Year
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;

  let fyStartYear;
  let fyEndYear;

  if (month >= 4) {
    fyStartYear = year;
    fyEndYear = year + 1;
  } else {
    fyStartYear = year - 1;
    fyEndYear = year;
  }

  const fiscalYearRange = `${fyStartYear}-${String(fyEndYear).slice(-2)}`;

  // ✅ Safe JSON parse
  const parseJSON = (val) => {
    try {
      return JSON.parse(val || "[]");
    } catch {
      return [];
    }
  };

  // ✅ Coordinator mapping
  // const getCoordinator = (subject) => {
  //   const c = data.coordinators?.find(
  //     (x) => x.subject?.toLowerCase() === subject
  //   );
  //   return c ? `${c.name} / ${c.mobile}` : "-";
  // };

  const getCoordinator = (subject) => {
    if (subject == "9999") {
      const c = data.coordinators?.find(
        (x) => x.subId == "9999");
        
      return c ? `${"General Coordinator"} / ${c.mobile}` : "-";
    }
    const c = data.coordinators?.find(
      (x) => String(x.subject)?.toLowerCase() === String(subject)?.toLowerCase());

    return c ? `${c.name} / ${c.mobile}` : "-";
  };

  // ✅ Student Rows
  // const studentRows = data.studentRegistrationSummary
  //   ?.map(
  //     (row) => `
  //     <tr>
  //       <td>${row.class}</td>
  //       <td>${row.science || ""}</td>
  //       <td>${row.maths || ""}</td>
  //       <td>${row.english || ""}</td>
  //       <td>${row.gk_iq || ""}</td>
  //       <td>${row.reasoning || ""}</td>
  //     </tr>
  //   `
  //   )
  //   .join("");

  const studentRows = data.studentRegistrationSummary
    ?.filter(
      (row) =>
        Number(row.science || 0) > 0 ||
        Number(row.maths || 0) > 0 ||
        Number(row.english || 0) > 0 ||
        Number(row.gk_iq || 0) > 0 ||
        Number(row.reasoning || 0) > 0
    )
    .sort((a, b) => {
      const getClassNumber = (cls) =>
        parseInt(String(cls).replace(/[^0-9]/g, "")) || 0;

      return getClassNumber(a.class) - getClassNumber(b.class);
    })
    .map(
      (row) => `
    <tr>
      <td>${row.class}</td>
      <td>${row.science || ""}</td>
      <td>${row.maths || ""}</td>
      <td>${row.english || ""}</td>
      <td>${row.gk_iq || ""}</td>
      <td>${row.reasoning || ""}</td>
    </tr>
  `
    )
    .join("");
  // ✅ Study Material Rows
  // const studyRows = data.studyMaterialSummary
  //   ?.map(
  //     (row) => `
  //     <tr>
  //       <td>${row.class}</td>
  //       <td>${row.science || ""}</td>
  //       <td>${row.maths || ""}</td>
  //       <td>${row.english || ""}</td>
  //       <td>${row.gk_iq || ""}</td>
  //       <td>${row.reasoning || ""}</td>
  //     </tr>
  //   `
  //   )
  //   .join("");

  const studyRows = data.studyMaterialSummary
    ?.filter(
      (row) =>
        Number(row.science || 0) > 0 ||
        Number(row.maths || 0) > 0 ||
        Number(row.english || 0) > 0 ||
        Number(row.gk_iq || 0) > 0 ||
        Number(row.reasoning || 0) > 0
    )
    .sort((a, b) => {
      const getClassNumber = (cls) =>
        parseInt(String(cls).replace(/[^0-9]/g, "")) || 0;

      return getClassNumber(a.class) - getClassNumber(b.class);
    })
    .map(
      (row) => `
      <tr>
        <td>${row.class}</td>
        <td>${row.science || ""}</td>
        <td>${row.maths || ""}</td>
        <td>${row.english || ""}</td>
        <td>${row.gk_iq || ""}</td>
        <td>${row.reasoning || ""}</td>
      </tr>
    `
    )
    .join("");
    
    const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };
  const htmlContent = `
  <div style="padding:2px; font-family: Arial; font-size:12px;">

    <!-- HEADER -->
    <div style="display:flex; justify-content:space-between; align-items:center;">
      <img src="${LogoMittsure}" style="width:150px"/>
      <div>
        <p><b style="font-size:'10px'">Date:</b> ${new Date().toLocaleDateString()}</p>
        <p><b>RNO/SO #:</b> ${data.schoolInfo.rno_id}</p>
      </div>
    </div>

    <p style="text-align:center; font-size:18px; font-weight:600; color:#000;">Mittsure Technologies LLP</p>
    <p style="text-align:center; margin-top:2px; padding:0px;font-size:14px; color:#000; font-weight:600">MOM Registration Summary (${fiscalYearRange})</p>

    <!-- SCHOOL DETAILS -->
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <td><b  style="color:#000; font-weight:600;">MOM School Code: </b> <span style="color:#000; font-weight:500; font-size:11px;" >${data.schoolInfo.partyId || "N/A"}</span></td>
        <td><b style="color:#000; font-weight:600;">District Code:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${data.schoolInfo.mom_district_code || "N/A"}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">School Name:</b><span style="color:#000; font-weight:500; font-size:11px;" > ${data.schoolInfo.schoolName}</span></td>
        <td><b style="color:#000; font-weight:600;">State:</b><span style="color:#000; font-weight:500; font-size:11px;" > ${data.schoolInfo.schoolState || "N/A"}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">RM/ARM:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${data.schoolInfo.userName}</span></td>
        <td><b style="color:#000; font-weight:600;">RM Contact:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${data.schoolInfo.userMobileNumber || "N/A"}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Registration Type:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${data.schoolInfo.RegistrationType}</span></td>
        <td><b style="color:#000; font-weight:600;">Date of Olympiad:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${formatDate(data.schoolInfo.olympiad_date)}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Medium:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${data.schoolInfo.reg_medium_name}</span></td>
        <td><b style="color:#000; font-weight:600;">Mode of Payment:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${parseJSON(
    data.schoolInfo.mode_of_payment
  ).join(", ")}</span></td>  
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Order Status:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${data.schoolInfo.transactionStatus}</span></td>
        <td><b style="color:#000; font-weight:600;">Sci Coordinator:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${getCoordinator("science")}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">Maths Coordinator:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${getCoordinator("maths")}</span></td>
        <td><b style="color:#000; font-weight:600;">Eng Coordinator:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${getCoordinator("english")}</span></td>
      </tr>
      <tr>
        <td><b style="color:#000; font-weight:600;">GK Coordinator:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${getCoordinator("gk_id")}</span></td>
        <td><b style="color:#000; font-weight:600;">Reasoning Coordinator:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${getCoordinator("reasoning")}</span></td>
      </tr>
       <tr>
        <td><b style="color:#000; font-weight:600;">General Coordinator:</b> <span style="color:#000; font-weight:500; font-size:11px;" >${getCoordinator("9999")}</span></td>
      </tr>
    </table>
        <p style="margin-top:2px;"><b style="color:#000; font-weight:600;">Admin Remark:</b> ${data.schoolInfo.adminRemark || "-"}</p>

    <!-- STUDENT REGISTRATION SUMMARY -->
    <h4 style="color:#000; font-weight:600;">Student Registration Summary</h4>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th style="padding:6px; background:#dce3dd; color:#000;">Class</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Science</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Maths</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">English</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">GK & IQ</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Reasoning</th>
      </tr>
      ${studentRows}
      <tr>
        <td><b>Total</b></td>
        <td colspan="5"><b>${data.registrationTotals.totalRegistrations}</b></td>
      </tr>
    </table>

    <p style="font-weight:600; color:#000;"><b>Total Registration Amount:</b> ₹${data.registrationTotals.totalAmount}</p>

    <!-- STUDY MATERIAL SUMMARY -->

    <h4 style="color:#000; font-weight:600;">Study Material Summary</h4>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th style="padding:6px; background:#dce3dd; color:#000;">Class</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Science</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Maths</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">English</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">GK & IQ</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Reasoning</th>
      </tr>
      ${studyRows}
      <tr>
        <td><b>Total</b></td>
        <td colspan="5"><b>${data.studyMaterialTotals.totalBooks}</b></td>
      </tr>
    </table>

    <p style="font-weight:600; color:#000;"><b>Total Books Amount:</b> ₹${data.studyMaterialTotals.totalAmount}</p>

    <!-- PAYMENT SUMMARY -->
    <h4 style="color:#000; font-weight:600;">Payment Summary</h4>
    <table border="1" style="width:100%; border-collapse:collapse;">
      <tr>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Registration Amount</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Study Material Amount</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Payable Amount</th>
        <th style="padding:6px; background:#dce3dd; color:#000;">Total Paid Amount</th>
      </tr>
      <tr>
        <td style={{ color: "#000", fontWeight: "600", }}>₹${data.paymentSummary.registrationAmount}</td>
        <td style={{ color: "#000", fontWeight: "600", }}>₹${data.paymentSummary.studyMaterialAmount}</td>
        <td style={{ color: "#000", fontWeight: "600", }}>₹${data.paymentSummary.totalPayableAmount}</td>
        <td style={{ color: "#000", fontWeight: "600", }}>₹${data.paymentSummary.totalPaidAmount}</td>
      </tr>
    </table>

  </div>
  `;

  const element = document.createElement("div");
  element.innerHTML = htmlContent;

  html2pdf()
    .set({
      margin: 5,
      filename: `Olympiad_${data.schoolInfo.rno_id}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
    })
    .from(element)
    .save();
};

export default downloadOlympiadPDF;